import VIconButton from '@voly/ui-components/src/v2/VIconButton.jsx';
import VMaterialIcon from '@voly/ui-components/src/v2/icons/VMaterialIcon.jsx';
import VTooltip from '@voly/ui-components/src/v2/VTooltip.jsx';
import { ComponentProps, ReactElement } from 'react';

const DISABLED_OPACITY = 0.3;

export type TBulkActionIcon = 'contentCopy' | 'delete' | 'download' | 'driveFileMove' | 'edit';

export type TBulkActionButtonProps = ComponentProps<'button'> & {
  icon: TBulkActionIcon;
  label: string;
  disabledReason?: string;
};

const BulkActionButton = ({
  icon,
  label,
  disabledReason,
  onClick,
  ...buttonProps
}: TBulkActionButtonProps): ReactElement => {
  const isDisabled = Boolean(disabledReason);

  return (
    <VTooltip content={disabledReason} disabled={!isDisabled}>
      <VIconButton
        aria-label={label}
        variant="plain"
        height="auto"
        flexDirection="column"
        color="fg.muted"
        fontWeight="semibold"
        cursor={isDisabled ? 'not-allowed' : 'pointer'}
        opacity={isDisabled ? DISABLED_OPACITY : undefined}
        _hover={isDisabled ? undefined : { color: 'primary.fg' }}
        aria-disabled={isDisabled}
        onClick={isDisabled ? undefined : onClick}
        {...buttonProps}
      >
        <VMaterialIcon name={icon} />
        {label}
      </VIconButton>
    </VTooltip>
  );
};

export default BulkActionButton;
